import { useEffect } from 'react';
import { useAppContext } from './core/context';
import { RouteNames, Routes } from './Routes';
import { trackRouteChange } from './core/instrumentation/sentry';
import ErrorView from './views/ErrorView';
import InputView from './views/InputView';
import StatusView from './views/StatusView';
import TimeoutView from './views/TimeoutView';
import PaymentResultView from './views/PaymentResultView';
import Main from './components/Main/Main';

export function Router(): React.ReactNode {
  const context = useAppContext();

  useEffect(() => {
    trackRouteChange(RouteNames[context.currentRoute]);
  }, [context.currentRoute]);

  let view: React.ReactNode;
  let showCancelLink = false;
  switch (context.currentRoute) {
    case Routes.ERROR:
      view = <ErrorView />;
      break;
    case Routes.STATUS:
      view = <StatusView />;
      showCancelLink = true;
      break;
    case Routes.SUCCESS:
      view = <PaymentResultView outcome="success" />;
      break;
    case Routes.CANCELLED:
      view = <PaymentResultView outcome="cancelled" />;
      break;
    case Routes.TIMEOUT:
      view = <TimeoutView />;
      break;
    default:
      view = <InputView />;
      showCancelLink = true;
      break;
  }
  return <Main showCancelLink={showCancelLink && context.claims !== null}>{view}</Main>;
}
